module.exports = __webpack_public_path__ + "static/media/Vectorday.7cd7597a.svg";